import { useVillaTranslation } from "@website/accommodation-ui/villa-search/villa-search-panel/hooks/use-villa-translation";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
import pick from "lodash-es/pick";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";

export const useHistory = (onChangeDestination: (item: any) => void) => {
  const router = useRouter();
  const [history, setHistory] = useState<
    Array<{ destination: any; startDate: string; endDate: string }>
  >([]);

  const { translateEntity } = useVillaTranslation();

  const VILLA_SEARCH_HISTORY_LOCAL_STORAGE_KEY = "villa-search-history-v2";

  useEffect(() => {
    if (localStorage) {
      const historyString = localStorage.getItem(
        VILLA_SEARCH_HISTORY_LOCAL_STORAGE_KEY
      );
      const history = historyString ? JSON.parse(historyString) : [];
      setHistory(history);
    }
  }, []);

  const addToHistory = useCallback(
    (destination: any, startDate: any, endDate: any, passengerNumber: any) => {
      if (localStorage) {
        const historyString = localStorage.getItem(
          VILLA_SEARCH_HISTORY_LOCAL_STORAGE_KEY
        );
        const history = historyString ? JSON.parse(historyString) : [];

        let newHistory = history.filter(
          (item: any) =>
            toString(item.destination.id) !== toString(destination.id)
        );

        const newHistoryItem = {
          destination,
          startDate,
          endDate,
          passengerNumber
        };
        newHistory = [newHistoryItem, ...newHistory].slice(0, 4);

        localStorage.setItem(
          VILLA_SEARCH_HISTORY_LOCAL_STORAGE_KEY,
          JSON.stringify(newHistory)
        );
        setHistory(newHistory);
      }
    },
    []
  );

  const onSelectHistory = useCallback(
    (id: string) => {
      if (history) {
        let historyItem = null;
        for (const element of history) {
          const checkKey = `${element.destination.id}`;
          if (`${id}` === checkKey) {
            historyItem = element.destination;
            break;
          }
        }

        if (historyItem) {
          onChangeDestination(historyItem);
        }
      }
    },
    [history, onChangeDestination]
  );

  const historyListNormalized = useMemo(
    () =>
      history
        .filter(
          ({ destination }) =>
            destination?.title && destination?.url && destination?.type
        )
        .map(({ destination }) => ({
          ...pick(destination, ["id", "title"]),
          subtitle: translateEntity(destination.subtitle),
          StartIcon: <MaterialIcon name="history" variant="outlined" />,
          Meta: (
            <div className="text-on-surface-high-emphasis text-caption">
              {`${numberConvert(destination.hotel_count, {
                locale: router.locale
              })} اقامتگاه`}
            </div>
          )
        })),
    [history, router.locale, translateEntity]
  );

  return {
    historyListNormalized,
    addToHistory,
    onSelectHistory
  };
};
